export const ARCHIVE_MODULES_REQUEST = 'ARCHIVE_MODULES_REQUEST'
export const ARCHIVE_MODULES_SUCCESS = 'ARCHIVE_MODULES_SUCCESS'
export const ARCHIVE_MODULES_FAILURE = 'ARCHIVE_MODULES_FAILURE'

export const SHOW_ARCHIVED_REQUEST = 'SHOW_ARCHIVED_REQUEST'
export const SHOW_ARCHIVED_SUCCESS = 'SHOW_ARCHIVED_SUCCESS'
export const SHOW_ARCHIVED_FAILURE = 'SHOW_ARCHIVED_FAILURE'

export const EXPORT_ARCHIVED_REQUEST = 'EXPORT_ARCHIVED_REQUEST'
export const EXPORT_ARCHIVED_SUCCESS = 'EXPORT_ARCHIVED_SUCCESS'
export const EXPORT_ARCHIVED_FAILURE = 'EXPORT_ARCHIVED_FAILURE'


// WEBPACK FOOTER //
// ./src/constants/training_module.js